module.exports = __webpack_public_path__ + "static/media/dolne-we-atmo.0469616d.svg";